import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';
import {
  AddShiftWorkbenchSettings,
  DeleteShiftWorkbenchSettings,
  EditShiftWorkbenchSettings,
  getShiftWorkbenchSettings,
} from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
interface IState {
  visibleAddDialog: boolean;
  visibleEditDialog: boolean;
  visibleDeleteDialog: boolean;
  truckFactorData: any;
}
interface IProps {
  GridHeight?: any;
}
export class SourceLocation extends Component<IProps, IState> {
  private securityRoleGrid: GridComponent;
  private sourceLocationsId: number = -1;
  private isAdd: boolean = true;
  private type = 'sourcelocation';
  constructor(props: IProps) {
    super(props);
    this.securityRoleGrid = new GridComponent(props);
    this.state = {
      visibleAddDialog: false,
      visibleEditDialog: false,
      visibleDeleteDialog: false,
      truckFactorData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh-m',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public validationRule: Object = { required: true };
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  deleteSource() {
    const obj = {
      id: this.sourceLocationsId,
    };

    DeleteShiftWorkbenchSettings(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getSourceLocation(this.type);
        this.setState({ visibleDeleteDialog: false });
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addSourceLocation(objCommer: any) {
    loadingShow(true, 'Adding');
    const obj = {
      app: 'UWORK',
      user_id: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      s_location_description: objCommer.s_location_description,
      s_location_code: objCommer.s_location_code,
      id: objCommer.id,
      type: this.type,
    };

    if (this.isAdd) {
      delete obj.id;
      AddShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);

          Message.success('Successfully');
          this.getSourceLocation(this.type);
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);

          Message.success('Successfully');
          this.getSourceLocation(this.type);
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  }
  componentDidMount() {
    this.getSourceLocation(this.type);
  }

  getSourceLocation(type: string) {
    getShiftWorkbenchSettings(type)
      .then((el) => {
        this.setState({ truckFactorData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }

  actionBegin(args: any) {
    if (args.requestType === 'refresh-m') {
      this.getSourceLocation(this.type);
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addSourceLocation(args.data);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addSourceLocation(args.data);
    } else if (args.requestType === 'delete') {
      this.sourceLocationsId = args.data[0].id;
      this.deleteSource();
    }
  }

  render() {
    return (
      <div>
        <GridComponent
          id='gridShiftworkbenchSourceLocation'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.truckFactorData}
          height='65vh'
          ref={(theGrid: GridComponent) => (this.securityRoleGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          enablePersistence
          allowExcelExport
          allowResizing={true}
          allowGrouping={true}
          actionBegin={this.actionBegin.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='s_location_code'
              headerText='Source Location Code'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='s_location_description'
              headerText='Source Location Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              ColumnChooser,
              ExcelExport,
              Page,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default SourceLocation;
